<template>
    <div class="searchBilan d-flex align-items-center justify-content-between mt-100">
        <div class="w-60">
            <h2 class="text-uppercase">
                Trouvez le Centre de Bilan <br />
                <span class="span-background-red">
                    le plus proche de chez vous
                </span>
            </h2>
        </div>
        <div>
            <nuxt-img src="/images/pages/bilan-competences/Vector 4.png"></nuxt-img>
        </div>
        <div class="w-20">
            <a class="btn-rouge-outline" href="/bilan_competences/nos_centres"><i
                    class="fa-regular fa-location-dot"></i>
                Nos centres</a>
        </div>
    </div>
</template>
<script setup>

</script>
<style scoped>
.searchBilan {
    padding: 90px 290px;
}

.searchBilan h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
    text-align: center;
}

.subtitle {
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    /* 27.93px */
    letter-spacing: 0.84px;
    text-decoration-line: underline;
}

.searchBilan ul {
    margin: 0;
    padding: 0 2rem 0 2rem;
    list-style-type: disc;
}

.searchBilan p {
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
}

.bold {
    font-weight: 600;
}

.searchBilan .btn-transparent {
    font-size: 20px;
}

.w-60 {
    width: 60%;
}

.w-20 {
    width: 20%;
}

.btn-rouge-outline {
    /* button-xl */
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    /* 27px */
    letter-spacing: 0.8px;
}

@media only screen and (min-width: 300px) and (max-width: 500px) {
    .searchBilan {
        padding: 21px 11px;
    }

    h2,
    .span-background-red {
        font-size: 14px !important;
        line-height: normal !important;
    }

    .searchBilan img {
        max-width: 50%;
    }

    .w-60,
    .w-20 {
        width: unset;
    }
}

@media only screen and (min-width: 501px) and (max-width: 768px) {

    h2,
    .span-background-red {
        font-size: 20px !important;
        line-height: normal !important;
    }

    .searchBilan {
        padding: 80px 102px;
    }

    .searchBilan img {
        max-width: 80%;
    }
}


@media only screen and (min-width: 769px) and (max-width: 991px) {}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .searchBilan[data-v-dfba3e70] {
        padding: 90px 70px;
    }
}

@media only screen and (min-width: 1200px) {}

/** ecran 1280 * 1024  */

@media screen and (min-width: 1088px) and (max-width: 1381px) {
    .searchBilan[data-v-dfba3e70] {
        padding: 90px 200px;
    }

    .w-20 {
        white-space: nowrap;
    }

    h2,
    .span-background-blue,
    .titre-section,
    .titre-section span {
        font-size: 2.13rem !important;
    }
}

@media only screen and (min-width: 938px) and (max-width: 1275px) {

}
</style>